import { useEffect, useState } from "react";
import Modal from "../../../../atom/modal";
import DevicesIcon from "@mui/icons-material/Devices";
import ComponentMap from "../../../../atom/componentmap";
import ThemedButton from "../../../../atom/ThemedButton/themedButton";
import { addDevice, getUsers } from "../../../../services/api";
import {
  addAKeyValueFromRefListItems,
  addChildrensToMapData,
  updateObjectKeyValue,
} from "../../../../services/utilities";
import Notification from "../../../../atom/Notification";
import Devices from "../devices";
import { useTranslation } from "react-i18next";
import { RootState } from "../../../../store/reducers";
import { useSelector } from "react-redux";

function AddSipDevice(props: any) {
  const { t } = useTranslation();

  const {
    setModal,
    childStatus,
    setchildStatus,
    getUserDetails,
    activeItem = {},
    devices,
    deviceChange,
    setDeviceChange,
  } = props;
  const [status, setStatus] = useState<any>("false");
  const [buttonLoader, setButtonloader] = useState<any>(false);
  const { userSettings } = useSelector((state: RootState) => state?.Auth);

  const isUser =
    userSettings?.roles_l?.length === 1 && userSettings?.roles_l[0] === "user";
  const [data, setData] = useState([
    {
      title: t("Control.Devices.Name"),
      name: "name",
      layout: 3,
      value: "",
      required: true,
      errormessage: t("Control.Devices.NameIsRequired"),
    },
    {
      name: "type",
      title: t("Control.Devices.Type"),
      value: "sip",
      hidden: true,
    },

    {
      title: t("Control.Devices.Username"),
      name: "login",
      layout: 3,
      value: "",
      required: true,
      errormessage: t("Control.Devices.UserNameIsRequired"),
    },
    {
      name: "user_id.uuid",
      title: t("Control.Devices.AssignedTo"),
      type: "dropdown",
      displayProps: { label: "label", value: "uuid" },
      childrens: [],
      hidden: Object.keys(activeItem).length === 0 ? false : true,
      layout: 3,
      value: "none",
      required: true,

      errormessage: t("Control.Devices.PleaseSelectaPerson"),
    },
    {
      title: t("Control.Devices.NotifyOnUnregister"),
      name: "notify_on_unregister",
      layout: 6,
      type: "checkbox",
      value: false,
    },
  ]);

  console.log("activeItem", activeItem);

  const onSave = (result: any) => {
    setButtonloader(true);
    result["user_id"] = result["user_id.uuid"];
    if (Object.keys(activeItem).length !== 0) {
      result.user_id = activeItem?.uuid;
    }

    delete result["user_id.uuid"];
    if (result.login.includes(" ")) {
      Notification(
        t("Control.Features.Failed"),
        "Username Should not contain Whitespace",
        "danger"
      );
      setButtonloader(false);
    } else {
      addDevice(result)
        .then((result: any) => {
          if (result?.data?.parameter || result?.data?.reason) {
            let msg = result?.data?.reason;
            Notification(
              t("Control.Features.Failed"),
              msg?.charAt(0).toUpperCase() + msg?.slice(1),
              "danger"
            );
            setButtonloader(false);
            setModal("");
            setStatus("true");
          } else {
            Notification(
              "Success",
              t("Control.Devices.DeviceAddedSuccessfully"),
              "success"
            );
            setButtonloader(false);
            setModal("");
            setStatus("true");
          }
          setchildStatus(!childStatus);

          if (Object.keys(activeItem).length !== 0 && activeItem?.first_name) {
            getUserDetails();
            setButtonloader(false);
            setModal("");
            setStatus("true");
          }
        })
        .catch((error: any) => {
          console.log("errorerrorerrorerror", error?.response?.data);
          let msg =
            error?.response?.data?.parameter === "Cell Number"
              ? `Username Already Exists.`
              : error?.response?.data?.reason;
          Notification(
            "Error",
            msg ? msg?.charAt(0).toUpperCase() + msg?.slice(1) : "Error",
            "danger"
          );
          setchildStatus(!childStatus);
          setButtonloader(false);
          setModal("");
          setStatus("true");
        });
    }
  };

  const onCancel = () => {
    setModal("");
  };

  // const getAssignedValues = () => {
  //   let copyData = [...data];
  //   //dropdown is hidden for users
  //   if (isUser) {
  //     copyData = updateObjectKeyValue(
  //       [...copyData],
  //       "user_id.uuid",
  //       "hidden",
  //       true
  //     );
  //     setData(copyData);
  //   }

  //   getUsers({}).then((result: any) => {
  //     let UpdatedResult = addAKeyValueFromRefListItems(result, "label", [
  //       "first_name",
  //       "last_name",
  //     ]);
  //     UpdatedResult = UpdatedResult.filter((node: any) => {
  //       return node.status !== "disabled";
  //     });
  //     //dropdown is hidden for userso set defautlt dropdowwn value
  //     copyData = isUser
  //       ? updateObjectKeyValue(
  //           [...copyData],
  //           "user_id.uuid",
  //           "value",
  //           UpdatedResult[0]?.uuid
  //         )
  //       : copyData;
  //     UpdatedResult.unshift({ label: "None", uuid: "none" });
  //     copyData = addChildrensToMapData(
  //       [...data],
  //       UpdatedResult,
  //       "user_id.uuid"
  //     );
  //     setData(copyData);
  //   });
  // };

  const getAssignedValues = () => {
    let updatedData = [...data];

    // Hide the dropdown and set default value if the user is restricted
    if (isUser) {
      updatedData = updateObjectKeyValue(
        updatedData,
        "user_id.uuid",
        "hidden",
        true
      );
      setData(updatedData);
    }

    // Fetch users and update dropdown options
    getUsers({}).then((result: any) => {
      let activeUsers = addAKeyValueFromRefListItems(result, "label", [
        "first_name",
        "last_name",
      ]).filter((user: any) => user.status !== "disabled");

      // Set default dropdown value for restricted users
      if (isUser && activeUsers[0]?.uuid) {
        updatedData = updateObjectKeyValue(
          updatedData,
          "user_id.uuid",
          "value",
          activeUsers[0].uuid
        );
      }

      // Map dropdown options to the main data
      activeUsers.unshift({ label: "None", uuid: "none" });
      updatedData = addChildrensToMapData(
        updatedData,
        activeUsers,
        "user_id.uuid"
      );
      setData(updatedData);
    });
  };
  useEffect(() => {
    getAssignedValues();
  }, [activeItem]);

  return (
    <div>
      <Modal
        icon={<DevicesIcon />}
        title={t("DashBoard.AddSipDevice")}
        closeEvent={() => {
          setModal("");
        }}
      >
        <div className="w-[700px]">
          <ComponentMap data={data} setData={setData} />
          <div className="text-right ">
            <ThemedButton
              children={t("Cancel")}
              icon="cancel"
              theme="secondary"
              click={onCancel}
            />
            <ThemedButton
              children={t("Save")}
              icon="update"
              theme="primary"
              valiData={data}
              change={setData}
              loading={buttonLoader}
              click={onSave}
            />
          </div>
        </div>
      </Modal>
      {status === "true" ? <Devices status={status} /> : null}
    </div>
  );
}

export default AddSipDevice;
